var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.GameScene = function (){
    EHDI.aka.Container.call(this);
    EHDI.GAME.gameScene = this;
    
    this.gameLayer = new EHDI.aka.Container();
    this.guiLayer = new EHDI.aka.Container();
    
    this.reelInput = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0x000000, EHDI.screen.stageWidth, EHDI.screen.stageHeight ) );
    this.reelInput.anchor.set(0.5, 0.5);
    this.reelInput.alpha = 0;

    var _this = this;
    var _catchData = { data : null, type : 0, rarity : 0 };
    var _commonData, _uncommonData, _rareData;
    
    this.addChild(this.gameLayer);
    this.addChild(this.reelInput);
    this.addChild(this.guiLayer);
    
    this.powerIndex = 1;
    
    var _bg;
    var _time = 0, _powerupTimer = 0;
    var _baseWaitTime = 5, 
        _waitInterval = EHDI.NumberUtil.randomRange( _baseWaitTime, _baseWaitTime * 2 );
    var _isWaiting = true, 
        _isEquipping = false, 
        _isTransition = false,
        _isReeling = false,
        _isPowerupOn = false,
        _isEndgame = false;
    
    var _doTutorial = false, 
        _tutorialStep = 0,
        _tutorialTime = 0,
        _tutorialOverlay;
    
    var _elementsContainer, _hudContainer;
    var _pauseButton, _checklistButton, _achieveButton;
    var _startTxt, _startButton;

    // for mobile test
    var _forceCatchIndex = 0, _forceJunkIndex = 0, _forcePowerIndex = 0;
    var _forceCatchButton, _forceJunkButton, _forcePowerButton, _forceAchieveButton;
    
    var _buttonTimeline = new TimelineMax( { autoRemoveChildren: true } );
    
    var setupDragonBones = function() {
        if(EHDI.GAME.dbFactory)
            return;
        EHDI.GAME.dbFactory = new dragonBones.PixiFactory();
        
        var textureImage = EHDI.Assets.images["char_bugs_tex"].baseTexture.source;
        var textureData = EHDI.Assets.cjAssets.getResult("char_bugs_tex");
        EHDI.GAME.dbFactory.addTextureAtlas(new dragonBones.TextureAtlas(textureImage, textureData));
        
        var skeleton = EHDI.Assets.cjAssets.getResult("char_bugs_ske");
        EHDI.GAME.dbFactory.addDragonBonesData(dragonBones.DataParser.parseDragonBonesData(skeleton));
        
        textureImage =  EHDI.Assets.images["objects_tex"].baseTexture.source;
        textureData = EHDI.Assets.cjAssets.getResult("objects_tex");
        EHDI.GAME.dbFactory.addTextureAtlas(new dragonBones.TextureAtlas(textureImage, textureData));
        
        skeleton = EHDI.Assets.cjAssets.getResult("objects_ske");
        EHDI.GAME.dbFactory.addDragonBonesData(dragonBones.DataParser.parseDragonBonesData(skeleton));
    }
    
    this.screenWillAppear = function() {
        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        _doTutorial = cache.isFirstTimePlay;
        
        setupDragonBones();
        this.pauseManager = new EHDI.manager.PauseManager();
        this.achievementPopup = new EHDI.popup.AchievementPopup();
        EHDI.GAME.achieveManager.setAchievementPopup( this.achievementPopup );
        EHDI.GAME.sceneManager.addNotification( this.achievementPopup );
        
        EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _buttonTimeline );
        
        this.powerIndex = 1;
        _commonData = EHDI.Assets.fetch( "rarity_0" );
        _uncommonData = EHDI.Assets.fetch( "rarity_1" );
        _rareData = EHDI.Assets.fetch( "rarity_2" );
        
        _bg = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0x29C0E2, EHDI.screen.viewWidth, EHDI.screen.viewHeight ) );
        _bg.anchor.set(0.5, 0.5);
        this.gameLayer.addChild(_bg);
    }
    
    this.screenDidAppear = function() {
        _this.reelInput.touchstart = _this.reelInput.mousedown = reelDown;
        _this.reelInput.interactive = true;
        
        _elementsContainer = new EHDI.component.ElementsContainer( reelDown );
        _elementsContainer.position.set( EHDI.screen.viewWidth * -0.5, EHDI.screen.viewHeight * -0.5 );
        this.gameLayer.addChild( _elementsContainer );
		
		_reelSession = new EHDI.component.ReelSession();
        _reelSession.position.set( EHDI.screen.viewWidth * -0.5, EHDI.screen.viewHeight * -0.5 );
        
        _pauseButton = new EHDI.displays.Button(EHDI.Assets.images["btn_pause"], null, null, null, 0.8);
        _pauseButton.position.set(EHDI.screen.viewWidth * 0.425, -EHDI.screen.viewHeight * 0.375);
        _pauseButton.setOnClickFunction(pauseButtonClicked);
        this.guiLayer.addChild( _pauseButton );
        
        _checklistButton = new EHDI.displays.Button(EHDI.Assets.images["btn_checklist"], null, null, null, 0.8);
        _checklistButton.position.set(-EHDI.screen.viewWidth * 0.425, -EHDI.screen.viewHeight * 0.375);
        _checklistButton.setOnClickFunction(openChecklist);
        this.guiLayer.addChild( _checklistButton );
        
        _achieveButton = new EHDI.displays.Button(EHDI.Assets.images["btn_achievement"], null, null, null, 0.8);
        _achieveButton.position.set(_checklistButton.position.x + _checklistButton.width * 1.05, -EHDI.screen.viewHeight * 0.375);
        _achieveButton.setOnClickFunction(openAchievementList);
        this.guiLayer.addChild( _achieveButton );
        
        _startButton = new EHDI.displays.Button(EHDI.Assets.images["btn_start"], null, null, null, 0.8);
        _startButton.position.set( 0, EHDI.screen.viewHeight * 0.325 );
        _startButton.setOnClickFunction(startGame);
        this.guiLayer.addChild( _startButton );
        
        _startTxt = new EHDI.aka.PixiText( EHDI.localization.strings["start"].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["start"].size, 
            align: 'center',
            wordWrap: true,
            wordWrapWidth: _startButton.width * 0.75,
            fill: '#FFFFFF'
        });
        _startTxt.anchor.set( 0.5, 0.5 );
        _startTxt.position.set( _startButton.width * -0.095, 0 );
        _startButton.addChild( _startTxt );
        
        _hudContainer = new EHDI.component.HudContainer();
        this.guiLayer.addChild( _hudContainer );
        
        EHDI.GAME.updateManager.addFrameListener(updateDBWorldClock);
        //EHDI.GAME.updateManager.addFrameListener(updateGame);
        
        /*
        _forceCatchButton = new EHDI.displays.Button(EHDI.Assets.images["btn_fishes_idle"], null, null, null, 0.8);
        _forceCatchButton.scale.set( 0.5 );
        _forceCatchButton.position.set(0, -EHDI.screen.viewHeight * 0.375);
        _forceCatchButton.setOnClickFunction(onForceButton);

        _forceJunkButton = new EHDI.displays.Button(EHDI.Assets.images["btn_junk_idle"], null, null, null, 0.8);
        _forceJunkButton.scale.set( 0.5 );
        _forceJunkButton.position.set(EHDI.screen.viewWidth * 0.1, -EHDI.screen.viewHeight * 0.375);
        _forceJunkButton.setOnClickFunction(forceJunk);

        _forcePowerButton = new EHDI.displays.Button(EHDI.Assets.images["btn_powerups_idle"], null, null, null, 0.8);
        _forcePowerButton.scale.set( 0.5 );
        _forcePowerButton.position.set(EHDI.screen.viewWidth * 0.2, -EHDI.screen.viewHeight * 0.375);
        _forcePowerButton.setOnClickFunction(forcePower);

        _forceAchieveButton = new EHDI.displays.Button(EHDI.Assets.images["btn_checklist"], null, null, null, 0.8);
        _forceAchieveButton.scale.set( 0.5 );
        _forceAchieveButton.position.set(EHDI.screen.viewWidth * 0.3, -EHDI.screen.viewHeight * 0.375);
        _forceAchieveButton.setOnClickFunction( EHDI.GAME.achieveManager.forceUnlock );

        this.guiLayer.addChild( _forceCatchButton );
        this.guiLayer.addChild( _forceJunkButton );
        this.guiLayer.addChild( _forcePowerButton );
        this.guiLayer.addChild( _forceAchieveButton );
        if( EHDI.BrowserInfo.deviceType === "desktop" ){
            //this.eventKeyDown = _this.onKeyDown;
            window.addEventListener( "keydown", _this.onKeyDown, false );
        }
        //*/
        
        
    }

    var onForceButton = function(){
        var code;
        switch( _forceCatchIndex ){
            case 0: code = "A"; break;
            case 1: code = "B"; break;
            case 2: code = "C"; break;
            case 3: code = "H"; break;
            case 4: code = "W"; break;
            case 5: code = "Y"; break;
            case 6: code = "G"; break;
            case 7: code = "J"; break;
            case 8: code = "L"; break;
            case 9: code = "M"; break;
            case 10: code = "O"; break;
            case 11: code = "P"; break;
            case 12: code = "R"; break;
            case 13: code = "S"; break;
            case 14: code = "T"; break;
            case 15: code = "N"; break;
            case 16: code = "D"; break;
            case 17: code = "U"; break;
            case 18: code = "K"; break;
            default: break;
        }
        _forceCatchIndex++;
        if( _forceCatchIndex > 18 ) _forceCatchIndex = 0;

        forceCatch( code );
    }
    
    this.onKeyDown = function( key ){
        if( !_isWaiting || _isReeling ) return;
        
        var keyCode = key.keyCode;
        if( keyCode !== 8 && keyCode !== 13 && ( keyCode < 64 || keyCode > 91 ) ) return;

        forceCatch( String.fromCharCode(keyCode) );
    }

    var forceCatch = function( keyCode ){
        var data;
        var rarity;
        switch( keyCode ){
            case "Z": EHDI.GAME.achieveManager.forceUnlock();
            case "A": data = _rareData.fish[1]; rarity = 2; break;
            case "B": data = _commonData.fish[2]; rarity = 0; break;
            case "C": data = _uncommonData.fish[0]; rarity = 1; break;
            case "H": data = _uncommonData.fish[3]; rarity = 1; break;
            case "W": data = _commonData.fish[0]; rarity = 0; break;
            case "Y": data = _commonData.fish[1]; rarity = 0; break;
            case "G": data = _uncommonData.fish[2]; rarity = 1; break;
            case "J": data = _rareData.fish[0]; rarity = 2; break;
            case "L": data = _uncommonData.fish[5]; rarity = 1; break;
            case "M": data = _commonData.fish[5]; rarity = 0; break;
            case "O": data = _rareData.fish[4]; rarity = 2; break;
            case "P": data = _uncommonData.fish[4]; rarity = 1; break;
            case "R": data = _rareData.fish[3]; rarity = 2; break;
            case "S": data = _uncommonData.fish[1]; rarity = 1; break;
            case "T": data = _commonData.fish[3]; rarity = 0; break;
            case "N": data = _uncommonData.fish[6]; rarity = 1; break;
            case "D": data = _rareData.fish[2]; rarity = 2; break;
            case "U": data = _commonData.fish[4]; rarity = 0; break;
            case "K": data = _commonData.fish[6]; rarity = 0; break;
            default: return; break;
        }
        console.log(data);
        
        var bonusWeight = 2;
        data.newWeight = (data.baseWeight * bonusWeight).toFixed(1);
        
        var strengthModifier = 1;
        strengthModifier = EHDI.NumberUtil.map( bonusWeight, 1.0, 2.0, 1.0, 0.6 );
        data.strength = data.strength * strengthModifier;
        data.pullStrength = ( _reelSession.BASE_STRENGTH * 0.1 ) - ( data.newWeight * data.strength ) - 5;
        
        _catchData.data = data;
        _catchData.type = 0;
        _catchData.rarity = rarity;
        // call catch object with index
        
        _isWaiting = false;
        if( _this.powerIndex === 1 ) _hudContainer.hideButtons();
        _elementsContainer.setNotifVisible( false );
        _elementsContainer.setBugsInteractive( false );
        _this.gameLayer.addChild( _reelSession );
        _elementsContainer.setCaughtFish( _catchData.data.asset, 0 );
        _this.reelInput.interactive = true;
        //_elementsContainer.setBugsAnimation( "rod_up", 1 );
        _this.startReelSession();
    }

    var forceJunk = function(){
        var data;
        var rarity;

        switch( _forceJunkIndex ){
            case 0: data = _commonData.junk[0]; rarity = 0; break;
            case 1: data = _commonData.junk[1]; rarity = 0; break;
            case 2: data = _uncommonData.junk[0]; rarity = 1; break;
            case 3: data = _rareData.junk[0]; rarity = 2; break;
        }
        _forceJunkIndex++;
        if( _forceJunkIndex > 3 ) _forceJunkIndex = 0;

        data.newWeight = data.baseWeight;
        data.newWeight = data.newWeight.toFixed(1);

        var rarityBonus = 1;
        if( rarity === 1 ) rarityBonus = 1.2;
        if( rarity === 2 ) rarityBonus = 1.3;
        
        data.pullStrength = ( _reelSession.BASE_STRENGTH * 0.1 ) - ( data.newWeight * data.strength * rarityBonus ) - 5;
        
        _catchData.data = data;
        _catchData.type = 2;
        _catchData.rarity = rarity;
        
        _isWaiting = false;
        if( _this.powerIndex === 1 ) _hudContainer.hideButtons();
        _elementsContainer.setNotifVisible( false );
        _elementsContainer.setBugsInteractive( false );
        _this.gameLayer.addChild( _reelSession );
        _elementsContainer.setCaughtFish( _catchData.data.asset, 2 );
        _this.reelInput.interactive = true;
        //_elementsContainer.setBugsAnimation( "rod_up", 1 );
        _this.startReelSession();
    }

    var forcePower = function(){
        var data;
        var rarity;

        switch( _forcePowerIndex ){
            case 0: data = _commonData.powerup[0]; rarity = 0; break;
            case 1: data = _commonData.powerup[1]; rarity = 0; break;
            case 2: data = _uncommonData.powerup[0]; rarity = 1; break;
            case 3: data = _rareData.powerup[0]; rarity = 2; break;
        }
        _forcePowerIndex++;
        if( _forcePowerIndex > 3 ) _forcePowerIndex = 0;

        data.newWeight = data.baseWeight;
        data.newWeight = data.newWeight.toFixed(1);

        var rarityBonus = 1;
        if( rarity === 1 ) rarityBonus = 1.2;
        if( rarity === 2 ) rarityBonus = 1.3;
        
        data.pullStrength = ( _reelSession.BASE_STRENGTH * 0.1 ) - ( data.newWeight * data.strength * rarityBonus ) - 5;
        
        _catchData.data = data;
        _catchData.type = 1;
        _catchData.rarity = rarity;
        
        _isWaiting = false;
        if( _this.powerIndex === 1 ) _hudContainer.hideButtons();
        _elementsContainer.setNotifVisible( false );
        _elementsContainer.setBugsInteractive( false );
        _this.gameLayer.addChild( _reelSession );
        _elementsContainer.setCaughtFish( _catchData.data.asset, 1 );
        _this.reelInput.interactive = true;
        //_elementsContainer.setBugsAnimation( "rod_up", 1 );
        _this.startReelSession();
    }
    
    var startGame = function(){
        _startButton.visible = false;
        _this.reelInput.interactive = false;
        if( !_doTutorial ) EHDI.GAME.updateManager.addFrameListener(updateGame);
        
        _elementsContainer.setBugsAnimation( "cast", 1 );
        EHDI.GAME.soundManager.playSFX("throw_fishing_line");
    }
    
    var updateDBWorldClock = function(dt) {
        if(_this.pauseManager.isPaused)
            return;
        dragonBones.WorldClock.clock.advanceTime(dt * 0.001);
    }
    
    var updateGame = function( dt ){
        if( _this.pauseManager.isPaused ) return;
        dt = dt / 1000;

        if( _tutorialStep === 2 ){
            _tutorialTime += dt;
            if( _tutorialTime > 4.5 ){
                EHDI.GAME.updateManager.removeFrameListener(updateGame);
                
                _tutorialStep = 3;
                proceedTutorial();
            }
            return;
        }
            
        _elementsContainer.update( dt );
        
        if( _isEquipping ) return;
        
		if( _isReeling ){
            _reelSession.update( dt );
            return;
        }

        if( _isEndgame ){
            EHDI.GAME.updateManager.removeFrameListener(updateGame);
            EHDI.GAME.gameScene.pauseManager.isPaused = true;
            EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.EndTransitionPopup(), {y : new EHDI.scene.TransitionParameter(- EHDI.screen.stageHeight, 0), duration : 0.25});
            // showpopup
            return;
        }
        
        _time += dt;
		if( _isWaiting ){
			if( _time > _waitInterval ){
                EHDI.GAME.soundManager.playSFX( "caught_something" );
                
                if( Math.random() < 0.15 ){
                    _catchData.data = null;
                    _elementsContainer.setNotifType( 0 );
                    _elementsContainer.setBugsAnimation( "notif_start", 1 );
                }
                else{
                    catchObject();
                    if( _catchData.data.pullStrength < -21 ){
                        _elementsContainer.setNotifType( 1 );
                        _elementsContainer.setBugsAnimation( "notif_start_heavy", 1 );
                    }
                    else{
                        _elementsContainer.setNotifType( 0 );
                        _elementsContainer.setBugsAnimation( "notif_start", 1 );
                    }         
                }
                
                _elementsContainer.setNotifVisible( true );
				_isWaiting = false;
                _time = 0;
                
                if( _buttonTimeline ) _buttonTimeline.kill();
                var hideHeight = EHDI.screen.viewHeight * -0.625;
                
                _buttonTimeline
                    .add( "hide", "+=0" )
                    .add( TweenMax.to( _checklistButton, 0.3, { y: hideHeight, ease : Power0.easeNone } ), "hide" )
                    .add( TweenMax.to( _achieveButton, 0.3, { y: hideHeight, ease : Power0.easeNone } ), "hide" )
                    .add( TweenMax.to( _pauseButton, 0.3, { y: hideHeight, ease : Power0.easeNone } ), "hide" );
                
                if( _this.powerIndex === 1 ) _hudContainer.hideButtons();
			}
            else{
                if( _isPowerupOn ){
                    _hudContainer.update( dt );
                }
            }
		}
		else{
			if( _time > 4.5 && !_isReeling ){
                _isReeling = true;
                _elementsContainer.setNotifVisible( false );
                _elementsContainer.setBugsAnimation( "notif_end", 1 );
                
                _baseWaitTime--;
                if( _baseWaitTime < 5 ) _baseWaitTime = 5;
                _waitInterval = EHDI.NumberUtil.randomRange( _baseWaitTime, _baseWaitTime * 2 );
			}
		}
	}
    
    var proceedTutorial = function(){
        var isMobile = EHDI.BrowserInfo.isMobileDevice ? "mobile_" : "desktop_";
        
        switch( _tutorialStep ){
            case 0:
                _tutorialOverlay.updateMessage( EHDI.localization.strings["tut1"].content, 0.0, 0.325 );
                _tutorialStep = 1;
                break;
                
            case 1:
                _tutorialOverlay.updateMessage( EHDI.localization.strings[ isMobile + "tut2"].content, 0.0, 0.325 );
                _tutorialStep = 2;
                break;
                
            case 2:
                _tutorialStep = 3;
                break;
                
            case 3:
                _isWaiting = false;
                
                EHDI.GAME.soundManager.playSFX( "caught_something" );
                _elementsContainer.setNotifVisible( true );
                _elementsContainer.setBugsAnimation( "notif_start", 1 );
                
                if( _buttonTimeline ) _buttonTimeline.kill();
                var hideHeight = EHDI.screen.viewHeight * -0.625;
                
                _buttonTimeline
                    .add( "hide", "+=0" )
                    .add( TweenMax.to( _checklistButton, 0.3, { y: hideHeight, ease : Power0.easeNone } ), "hide" )
                    .add( TweenMax.to( _achieveButton, 0.3, { y: hideHeight, ease : Power0.easeNone } ), "hide" )
                    .add( TweenMax.to( _pauseButton, 0.3, { y: hideHeight, ease : Power0.easeNone } ), "hide" );
                
                _tutorialOverlay.updateMessage( EHDI.localization.strings[ isMobile + "tut3"].content, 0.0, 0.325 );
                _tutorialStep = 4;
                
                var data = _commonData.fish[0];
                data.newWeight = data.baseWeight;
                data.newWeight = data.newWeight.toFixed(1);
                data.pullStrength = ( _reelSession.BASE_STRENGTH * 0.1 ) - ( data.newWeight * data.strength ) - 5;
                
                _catchData.data = data;
                _catchData.type = 0;
                _catchData.rarity = 0;
                break;
                
            case 4:
                //_tutorialOverlay.updateMessage( EHDI.localization.strings[ isMobile + "tut4"].content, 0.0, 0.325 );
                //_tutorialStep = 5;
                _tutorialStep = 6;
                _tutorialOverlay.hideMessage();
                EHDI.GAME.updateManager.addFrameListener(updateGame);
                
                break;
                
            case 6:
                var achieveStatus = EHDI.GAME.achieveManager.getUnlockedStates();
                if( achieveStatus[ 0 ] ) _tutorialOverlay.updateMessage( EHDI.localization.strings["tut5"].content, 0.0, 0.325 );
                break;
                
            default:
                break;
        }
    }
    
    var reelDown = function(){
        if( _isTransition ) return;
        
        if( !_isWaiting ){
			if( !_isReeling ){
                if( _doTutorial ){
                    if( _tutorialStep === 4 ){
                        _elementsContainer.setNotifVisible( false );
                        _elementsContainer.setBugsInteractive( false );
                        _this.gameLayer.addChild( _reelSession );
                        
                        _isTransition = true;
                        _this.reelInput.interactive = true;
                        
                        _tutorialOverlay.hideMessage();
                        _elementsContainer.setCaughtFish( _catchData.data.asset, _catchData.type );
                        _elementsContainer.setBugsAnimation( "rod_up", 1 );
                    }
                    return;
                }
                
				_time = 0;
				_elementsContainer.setNotifVisible( false );
                _elementsContainer.setBugsInteractive( false );
                _this.gameLayer.addChild( _reelSession );
                
                if( _catchData.data === null ){
                    _elementsContainer.setBugsAnimation( "catch", 1 );
                    _reelSession.reelNothing();
                    _isReeling = true;
                    _this.reelInput.interactive = true;
                    EHDI.GAME.achieveManager.updateCaughtNothing();
                    
                    _baseWaitTime = 5;
                    _waitInterval = EHDI.NumberUtil.randomRange( _baseWaitTime, _baseWaitTime * 2 );
					return;
                }
                else{
                    _isTransition = true;
                    _this.reelInput.interactive = true;
                    _elementsContainer.setBugsAnimation( "rod_up", 1 );
                }
			}
			else{
                /*
                if( _doTutorial && _tutorialStep === 5 ){
                    _tutorialStep = 6;
                    _tutorialOverlay.hideMessage();
                    EHDI.GAME.updateManager.addFrameListener(updateGame);
                }
                //*/
                
				_reelSession.reelFish();
			}
		}
        else{
            if( _doTutorial ){
                if( _tutorialStep === 1 ){
                    proceedTutorial();
                }
                else if( _tutorialStep === 2 ){
                    _isWaiting = false;
                    _this.reelInput.interactive = false;
                    _elementsContainer.setBugsInteractive( true );
                    EHDI.GAME.updateManager.addFrameListener(updateGame);
                    _tutorialOverlay.hideMessage();
                }
            }
        }
    }
    
    this.resetState = function(){
        if( _doTutorial ){
            _isReeling = false;
            
            _tutorialOverlay = new EHDI.component.TutorialOverlay();
            _this.guiLayer.addChild( _tutorialOverlay );
            
            proceedTutorial();
            _this.reelInput.interactive = true;
            return;
        }
        
        console.log( "reset state" );
        
        _time = 0;
        _isWaiting = true;
        _isEquipping = false;
        _isReeling = false;
        
        _this.reelInput.interactive = false;
        _elementsContainer.setBugsInteractive( true );
        _elementsContainer.setBugsAnimation( "idle1", 0 );
        
        if( _reelSession.parent ){
            _this.reelInput.interactive = false;
            _this.gameLayer.removeChild( _reelSession );
        }
        
        var showHeight = EHDI.screen.viewHeight * -0.375;
        _buttonTimeline
            .add( "show", "+=0" )
            .add( TweenMax.to( _checklistButton, 0.3, { y: showHeight, ease : Power0.easeNone } ), "show" )
            .add( TweenMax.to( _achieveButton, 0.3, { y: showHeight, ease : Power0.easeNone } ), "show" )
            .add( TweenMax.to( _pauseButton, 0.3, { y: showHeight, ease : Power0.easeNone } ), "show" );
        
        if( _this.powerIndex === 1 )    _hudContainer.showButtons();
        else                            _this.startPowerTimer( true ); // might fix issue we've been having?
    }
    
    this.endGame = function(){
        _isEndgame = true;
    }
    
    this.catchResult = function( didCatch ) {
        if( !didCatch ){
            _elementsContainer.setBugsAnimation( "struggle_fail", 1 );
        }
        else{
            _elementsContainer.setBugsAnimation( "struggle_catch", 1 );
            _elementsContainer.setSplashAnimation( "big_splash", 1 );
        }
    }
    
    this.reelMissed = function(){
        _this.gameLayer.addChild( _reelSession );
        _isReeling = true;
        _this.reelInput.interactive = true;
        _reelSession.reelEscape();
    }
    
    this.showReelResults = function(){
        _reelSession.setResultsVisible( true );
        if( _doTutorial ) proceedTutorial();
    }
    
    this.startReelSession = function(){
        if( _doTutorial && _tutorialStep === 4 ) proceedTutorial();
        
        _baseWaitTime++;
        if( _baseWaitTime > 15 ) _baseWaitTime = 15;
        _waitInterval = EHDI.NumberUtil.randomRange( _baseWaitTime, _baseWaitTime * 2 );
        
		_reelSession.startSession( _catchData.data, _catchData.type, _catchData.rarity );
        _isTransition = false;
        _isReeling = true;
    }
    
    this.updateReelAnim = function( index ){
        if( !_isReeling ) return;
        
        switch( index ){
            case 0: _elementsContainer.setBugsAnimation( "struggle_soft", 0 ); break;
            case 1: _elementsContainer.setBugsAnimation( "struggle_mid", 0 ); break;
            case 2: _elementsContainer.setBugsAnimation( "struggle_hard", 0 ); break;
            default: break;
        }
    }
    
    this.endReelSession = function(){
        if( _doTutorial ){
            var data = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
            data.isFirstTimePlay = false;
            _doTutorial = false;
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, data);        
            _tutorialOverlay.hideMessage();
        }
        
        _this.gameLayer.removeChild( _reelSession );
        _elementsContainer.setCaughtFishVisible( false );
        _elementsContainer.setBugsAnimation( "cast", 1 );
        EHDI.GAME.soundManager.playSFX("throw_fishing_line");
    }
    
    this.equipPower = function( id ){
        if( _isPowerupOn ) return;
        this.powerIndex = id;
        _isEquipping = true;
        _elementsContainer.setBugsAnimation( "equip", 1 );
    }
    
    this.resetPower = function(){
        _isPowerupOn = false;
        _isEquipping = true;
        
        var equipAnim = "equip_";
        if( this.powerIndex < 4 )   equipAnim += "hat";
        else                        equipAnim += "rod";
        
        this.powerIndex = 1;
        _hudContainer.hideButtons( true );
        _elementsContainer.setBugsAnimation( equipAnim, 1 );
    }
    
    this.startPowerTimer = function( activate ){
        var activate = activate || false;
        
        _isEquipping = false;
        if( activate ) _isPowerupOn = true;
    }
    
    var catchObject = function(){
		var rarityType = Math.floor ( EHDI.NumberUtil.randomRange( 0, 3 ) );
		
		var data;
        switch( rarityType ){
            case 0: data = _commonData; break;
            case 1: data = _uncommonData; break;
            case 2: data = _rareData; break;
        }
		var objectData;
		
		var catchType = Math.random();
		var fishChance = 0.66, powerupChance = 0.22;
        
        if( _this.powerIndex === 2 ){
			fishChance = 0.88;
			powerupChance = 0.075;
		}
		
		if( _this.powerIndex === 3 ){
			fishChance = 0.055;
			powerupChance = 0.055;
		}
		
		if( _this.powerIndex === 5 ){
			fishChance = 0.11;
			powerupChance = 0.77;
		}
		
		if( catchType < fishChance ){
			objectData = data.fish[ Math.floor ( EHDI.NumberUtil.randomRange( 0, data.fish.length ) ) ];
			
			var weightRange = Math.random();
			var startWeight = objectData.baseWeight;
			var weightBonus = 1;
			var strengthModifier = 1;
			
			if( weightRange < 0.4 )								weightBonus = EHDI.NumberUtil.randomRange( 100, 141 );
			else if( weightRange >= 0.4 && weightRange < 0.7 )	weightBonus = EHDI.NumberUtil.randomRange( 141, 171 );
			else if( weightRange >= 0.7 && weightRange < 0.9 )	weightBonus = EHDI.NumberUtil.randomRange( 171, 191 );
			else												weightBonus = EHDI.NumberUtil.randomRange( 191, 211 );
			
			weightBonus = Math.floor( weightBonus ) / 100;
			objectData.newWeight = objectData.baseWeight * weightBonus;
			
            if( _this.powerIndex === 4 ) objectData.newWeight = objectData.newWeight * 1.2;
            if( objectData.newWeight > startWeight * 2 ) objectData.newWeight = startWeight * 2;
            objectData.newWeight = objectData.newWeight.toFixed(1);
			
			strengthModifier = EHDI.NumberUtil.map( weightBonus, 1.0, 2.0, 1.0, 0.6 );
			objectData.strength = objectData.strength * strengthModifier;
			
			catchType = 0;
		}
		else if( catchType >= fishChance && catchType < fishChance + powerupChance ){
			objectData = data.powerup[ Math.floor ( EHDI.NumberUtil.randomRange( 0, data.powerup.length ) ) ];
            objectData.newWeight = objectData.baseWeight;
			catchType = 1;
		}
		else{
			objectData = data.junk[ Math.floor ( EHDI.NumberUtil.randomRange( 0, data.junk.length ) ) ];
            objectData.newWeight = objectData.baseWeight;
            objectData.newWeight = objectData.newWeight.toFixed(1);
			catchType = 2;
		}
        
        var rarityBonus = 1;
        if( rarityType === 1 ) rarityBonus = 1.2;
        if( rarityType === 2 ) rarityBonus = 1.3;
        
        objectData.pullStrength = ( _reelSession.BASE_STRENGTH * 0.1 ) - ( objectData.newWeight * objectData.strength * rarityBonus ) - 5;
        
        _catchData.data = objectData;
        _catchData.type = catchType;
        _catchData.rarity = rarityType;
        
        _elementsContainer.setCaughtFish( _catchData.data.asset, catchType );
	}
    
    var pauseButtonClicked = function() {
        _this.pauseManager.pauseGame();
        EHDI.GAME.soundManager.playSFX("button_01");
    }
    
    var openChecklist = function() {
        _this.pauseManager.readyPopUp( 0, _commonData, _uncommonData, _rareData );
        EHDI.GAME.soundManager.playSFX("button_01");
    }
    
    var openAchievementList = function(){
        _this.pauseManager.readyPopUp( 1, _commonData, _uncommonData, _rareData );
        EHDI.GAME.soundManager.playSFX("button_01");
    }
    
    this.popUpWillAppear = function() {
        _this.guiLayer.visible = false;
    }
    
    this.popUpDidDisappear = function() {
        _this.guiLayer.visible = true;
    }
    
    this.screenWillDisappear = function() {
        _this.pauseManager.endGame();
    }
    
    this.screenDidDisappear = function() {
        _elementsContainer.dispose();
        _reelSession.dispose();
        EHDI.GAME.gameScene.pauseManager.removeTimelineInterrupt( _buttonTimeline );
        
        EHDI.GAME.achieveManager.setAchievementPopup( null );
        EHDI.GAME.sceneManager.removeNotification( this.achievementPopup, true );
        
        dragonBones.WorldClock.clock.clear();
        
        EHDI.GAME.updateManager.removeFrameListener(updateDBWorldClock);
    }
    
    this.onScreenResize = function() {
        if( _buttonTimeline ) _buttonTimeline.kill();
        
        if( _isWaiting ){
            _pauseButton.position.y = -EHDI.screen.viewHeight * 0.375;
            _checklistButton.position.y = -EHDI.screen.viewHeight * 0.375;
            _achieveButton.position.y = -EHDI.screen.viewHeight * 0.375;
        }
        else{
            _pauseButton.position.y = -EHDI.screen.viewHeight * 0.625;
            _checklistButton.position.y = -EHDI.screen.viewHeight * 0.625;
            _achieveButton.position.y = -EHDI.screen.viewHeight * 0.625;
        }
        
        _pauseButton.position.x = EHDI.screen.viewWidth * 0.425;
        _checklistButton.position.x = -EHDI.screen.viewWidth * 0.425;
        _achieveButton.position.x = _checklistButton.position.x + _checklistButton.width * 1.05;
        
        _elementsContainer.onResize();
        if( _reelSession.parent ) _reelSession.onResize();
    }
    
};

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);